/** Textos do icone (i) de cada card e grafico, conforme o guia de metricas (PDF). */

export interface MetricInfo {
    calculo: string;
    leitura: string;
}

export const METRIC_INFO = {
    contasTotais: {
        calculo: 'Empresas cadastradas até a data final escolhida, inclusive as que perderam o acesso.',
        leitura: 'Tamanho do cadastro. Uma empresa conta uma vez.',
    },
    contasComAcesso: {
        calculo:
            'Empresas com assinatura ativa ou gratuita na data final. O percentual divide esse número por Contas totais.',
        leitura: 'Empresas que podem usar o produto.',
    },
    pagantesAtivas: {
        calculo:
            'Empresas com assinatura paga ativa na data final. O percentual divide esse número por Contas totais.',
        leitura: 'Tamanho da base pagante.',
    },
    mrr: {
        calculo:
            'Soma do valor mensal das assinaturas pagas ativas. O valor de planos anuais é dividido por 12 antes da soma.',
        leitura: 'Receita recorrente mensal da base atual.',
    },
    arr: {
        calculo: 'MRR multiplicado por 12.',
        leitura: 'Receita recorrente anualizada, diferente do dinheiro já recebido.',
    },
    churn: {
        calculo:
            'Pagantes do início do período que cancelaram ou expiraram durante o período, divididas por todas as pagantes do início, vezes 100. Com filtro de status, a taxa fica indisponível.',
        leitura: 'Parcela da base pagante inicial que saiu.',
    },
    crescimentoPagantes: {
        calculo:
            'Pagantes ativas no fim menos pagantes ativas no início, dividido pelas pagantes ativas no início, vezes 100. A diferença em empresas aparece abaixo do percentual.',
        leitura: 'Crescimento ou queda líquida da base pagante.',
    },
    novasContas: {
        calculo:
            'Empresas cadastradas entre as datas escolhidas. A comparação usa o período anterior de mesma duração.',
        leitura: 'Entrada no cadastro, mesmo sem pagamento.',
    },
    cancelamentos: {
        calculo:
            'Empresas cujo cancelamento (ou expiração da assinatura) ocorreu entre as datas escolhidas, contadas uma vez. A comparação usa o período anterior de mesma duração.',
        leitura: 'Volume de saídas.',
    },
    mrrCancelado: {
        calculo:
            'Soma do valor mensal equivalente das assinaturas canceladas ou expiradas no período. Um plano anual entra dividido por 12.',
        leitura: 'Receita recorrente mensal associada às saídas.',
    },
    tendenciaReceitaBase: {
        calculo:
            'Cada ponto refaz MRR, ARR, Pagantes ativas, Contas com acesso, Contas totais, Crescimento de pagantes ou Variação de pagantes na data ou intervalo correspondente. Variação de pagantes é a quantidade no fim menos a quantidade no início do intervalo.',
        leitura: 'Direção da base e da receita ao longo do tempo.',
    },
    tendenciaAquisicaoChurn: {
        calculo:
            'Cada ponto mostra Novas contas, Cancelamentos ou Churn no intervalo correspondente, pelas mesmas regras dos cards.',
        leitura: 'Compara entrada e saída de empresas.',
    },
    gratuitasTrial: {
        calculo:
            'Empresas com acesso gratuito na data final, divididas por Contas totais para obter o percentual.',
        leitura: 'Parte da base com acesso que ainda não paga.',
    },
    planosMensais: {
        calculo:
            'Pagantes ativas em plano mensal na data final, divididas por Contas totais para obter o percentual.',
        leitura: 'Participação dos planos mensais.',
    },
    planosAnuais: {
        calculo:
            'Pagantes ativas em plano anual na data final, divididas por Contas totais para obter o percentual.',
        leitura: 'Participação dos planos anuais.',
    },
    tempoMedioPrimeiroLancamento: {
        calculo:
            'Média de dias entre cadastro e primeiro lançamento entre as empresas que já lançaram. Empresas sem lançamento ficam fora da média.',
        leitura: 'Velocidade para começar a registrar as finanças.',
    },
    ativacaoD7: {
        calculo:
            'Pagantes que registraram informações e depois visualizaram uma análise financeira nos sete primeiros dias após o cadastro, divididas pelas pagantes que já tiveram sete dias completos para fazer isso, vezes 100. Empresas cadastradas antes do início do histórico de acesso ficam de fora, porque os primeiros dias delas não foram medidos.',
        leitura: 'Parcela que chegou rapidamente ao primeiro valor do produto.',
    },
    ttvMediano: {
        calculo:
            'Entre as pagantes ativas que já visualizaram uma análise financeira depois de registrar informações, contam-se os dias desde o cadastro. O card mostra o tempo central após ordenar esses tempos. Empresas sem essa análise ficam fora. Empresas cadastradas antes do início do histórico de acesso ficam de fora, porque os primeiros dias delas não foram medidos.',
        leitura: 'Tempo típico até perceber valor.',
    },
    funilAtivacao: {
        calculo:
            'Começa com empresas cadastradas no período que já tiveram sete dias completos de observação. Cada etapa conta apenas empresas que passaram pela anterior: Cadastrou, 1º acesso, Pesquisa, 1º lançamento, Retornou D7 e CRFA. Acesso é login com senha ou uso registrado do sistema. O percentual divide a etapa pelo total de Cadastrou. Empresas cadastradas antes do início do histórico de acesso ficam de fora, porque os primeiros dias delas não foram medidos.',
        leitura: 'Mostra em qual passagem da jornada as empresas deixam de avançar.',
    },
    contasNaEtapa: {
        calculo:
            'Lista as empresas da etapa selecionada no Funil de ativação, com as datas e lançamentos mostrados na tabela.',
        leitura: 'Permite conferir quem compõe cada etapa.',
    },
    setupD30: {
        calculo:
            'Entre empresas com pelo menos 30 dias desde o primeiro pagamento, conta as que fizeram ao menos dez lançamentos em dois dias diferentes e acessaram em dois dias diferentes nos primeiros 30 dias. O percentual divide esse grupo por todas as pagantes com 30 dias completos.',
        leitura: 'Empresas que montaram a rotina inicial segundo o critério exibido.',
    },
    pagouNuncaAcessou: {
        calculo:
            'Empresas com pagamento registrado e nenhum acesso ou outra ação no produto até a data final.',
        leitura: 'Pagantes que ainda não começaram a usar.',
    },
    crfa: {
        calculo:
            'Pagantes ativas que, nos últimos 28 dias, registraram informações financeiras, consultaram uma análise e fizeram ações de valor em pelo menos duas semanas diferentes. O percentual divide esse grupo por Pagantes ativas.',
        leitura: 'Rotina financeira contínua, além do simples acesso.',
    },
    dau: {
        calculo:
            'Empresas com acesso em que alguém acessou o sistema no dia mostrado (login com senha ou uso registrado de alguma tela), contadas uma vez. O percentual divide esse total por Contas com acesso.',
        leitura: 'Uso no dia.',
    },
    wau: {
        calculo:
            'Empresas com acesso em que alguém acessou o sistema nos últimos sete dias, incluindo o dia mostrado, contadas uma vez. O percentual divide esse total por Contas com acesso.',
        leitura: 'Uso na semana recente.',
    },
    mau: {
        calculo:
            'Empresas com acesso em que alguém acessou o sistema nos últimos 30 dias, incluindo o dia mostrado, contadas uma vez. O percentual divide esse total por Contas com acesso.',
        leitura: 'Uso no mês recente.',
    },
    ausentes: {
        calculo:
            'Empresas com acesso que já acessaram o sistema, mas cujo último acesso aconteceu há mais de 30 dias. O percentual divide esse total por Contas com acesso.',
        leitura: 'Quem usou antes e se afastou.',
    },
    nuncaAcessou: {
        calculo:
            'Empresas com acesso sem nenhum acesso registrado até a data mostrada. O percentual divide esse total por Contas com acesso.',
        leitura: 'Quem ainda não começou a usar.',
    },
    usuariosUnicosDia: {
        calculo: 'Pessoas diferentes que acessaram o sistema no dia mostrado, dentro das empresas com acesso.',
        leitura: 'Pessoas que entraram; DAU conta empresas.',
    },
    loginsDia: {
        calculo:
            'Total de logins com senha concluídos no dia mostrado, dentro das empresas com acesso. A mesma pessoa pode entrar várias vezes; sessão renovada automaticamente não conta.',
        leitura: 'Volume de acessos no dia.',
    },
    loginsPorConta30d: {
        calculo: 'Total de logins com senha nos últimos 30 dias dividido por Contas com acesso, incluindo empresas sem login.',
        leitura: 'Frequência média de login por empresa.',
    },
    sessoesPorContaMes: {
        calculo:
            'Sessões iniciadas desde o primeiro dia do mês mostrado divididas por Contas com acesso, incluindo empresas sem sessão.',
        leitura: 'Frequência média de sessões por empresa.',
    },
    tendenciaUso: {
        calculo: 'Cada ponto refaz CRFA, DAU, WAU, MAU, Ausentes ou Logins/conta · 30 dias para aquela data.',
        leitura: 'Mostra se o uso cresce, cai ou se mantém.',
    },
    movimentacoes: {
        calculo:
            'Lançamentos válidos (não cancelados) que as empresas registraram no período, somando entradas e saídas. A data é a do registro no sistema; um parcelamento conta como um registro.',
        leitura: 'Volume de registros feitos no produto.',
    },
    entradas: {
        calculo:
            'Soma dos valores das entradas registradas no período, sem canceladas; num parcelamento entram todas as parcelas. A quantidade de registros aparece abaixo.',
        leitura: 'Dinheiro que clientes registraram como entrada em suas próprias finanças.',
    },
    saidas: {
        calculo:
            'Soma dos valores das saídas registradas no período, sem canceladas; num parcelamento entram todas as parcelas. A quantidade de registros aparece abaixo.',
        leitura: 'Dinheiro que clientes registraram como saída em suas próprias finanças.',
    },
    resultado: {
        calculo: 'Valor de Entradas menos valor de Saídas no período.',
        leitura: 'Saldo dos lançamentos dos clientes, não receita do Financeiro Diário.',
    },
    tendenciaFuncionalidades: {
        calculo:
            'Cada ponto mostra uma opção no intervalo correspondente: Ações do evento conta ocorrências da ação escolhida no gráfico; Contas que usaram conta empresas que a fizeram; Lançamentos conta os registros financeiros válidos, com a mesma regra do card Movimentações, e não muda com a escolha do evento.',
        leitura: 'Evolução do alcance e da frequência de uso.',
    },
    featureFlags: {
        calculo:
            'Para cada funcionalidade, conta empresas nas quais ela está habilitada. O percentual divide esse número por Contas totais do filtro. Também mostra quantas das habilitadas são pagantes.',
        leitura: 'Disponibilidade da funcionalidade, sem afirmar que ela foi usada.',
    },
    movimentacoesPorCliente: {
        calculo:
            'Uma linha por empresa com quantidade e valor de entradas e saídas no período. Resultado é entradas menos saídas.',
        leitura: 'Identifica quem registrou movimentações e quanto registrou.',
    },
    maisUtilizadas: {
        calculo:
            'Cada linha representa uma ação. Contas conta empresas que a fizeram; Ações conta todas as ocorrências; Pagantes e Gratuitas contam empresas de cada grupo que a fizeram. Adoção pagantes divide as pagantes que fizeram a ação por todas as pagantes ativas; Adoção gratuitas divide as gratuitas que a fizeram por todas as gratuitas.',
        leitura: 'Distingue alcance da funcionalidade de frequência de uso.',
    },
    usoPorCliente: {
        calculo:
            'Cada barra mostra quantas vezes a empresa fez a ação escolhida no próprio gráfico durante o período. Só aparecem empresas com uso.',
        leitura: 'Mostra concentração de uso entre clientes.',
    },
    // Assinaturas > Geral (guia, p. 11-12)
    assinantesAtivos: {
        calculo: 'Empresas com assinatura paga ativa na data final. O percentual divide esse número por Contas totais.',
        leitura: 'Base pagante atual.',
    },
    gratuitas: {
        calculo: 'Empresas com assinatura gratuita na data final.',
        leitura: 'Acesso sem cobrança.',
    },
    mensais: {
        calculo: 'Empresas com assinatura paga ativa e cobrança mensal na data final.',
        leitura: 'Base ativa em plano mensal.',
    },
    anuais: {
        calculo: 'Empresas com assinatura paga ativa e cobrança anual na data final.',
        leitura: 'Base ativa em plano anual.',
    },
    emAtraso: {
        calculo:
            'Empresas com cobrança em atraso na data final. O valor em reais abaixo é a soma do valor mensal equivalente de seus planos.',
        leitura: 'Receita recorrente exposta ao atraso, sem tratá-la como perda definitiva.',
    },
    evolucaoAssinantes: {
        calculo:
            'Cada ponto mostra Pagantes ativas, Contas com acesso ou Contas totais na data correspondente, pelas mesmas regras da Visão geral.',
        leitura: 'Mudança da base ao longo do tempo.',
    },
    composicaoAssinaturas: {
        calculo:
            'Divide Contas totais entre Ativas, Em atraso, Gratuitas e Outras na data final. Cada percentual divide o tamanho do grupo por Contas totais. Outras reúne os demais estados: assinaturas suspensas, canceladas (inclusive por expiração), reembolsadas e contas sem assinatura.',
        leitura: 'Distribuição das situações de assinatura.',
    },
    assinaturasPorCliente: {
        calculo:
            'Uma linha por empresa, com plano, assinatura, pagamentos e vencimento. Dias em atraso conta os dias desde uma cobrança vencida ainda não paga. LTV pago soma o que a empresa pagou até a data mostrada. Clicar em um card filtra as empresas da tabela.',
        leitura: 'Explica os totais pela lista de clientes.',
    },
    // Assinaturas > Receitas (guia, p. 13)
    arpuMensal: {
        calculo: 'MRR dividido por Assinantes ativos.',
        leitura: 'Receita recorrente mensal média por empresa pagante.',
    },
    recebidoNoPeriodo: {
        calculo: 'Soma dos pagamentos registrados entre as datas selecionadas.',
        leitura: 'Dinheiro recebido no intervalo, diferente da receita recorrente da base atual.',
    },
    ltvMedioPago: {
        calculo:
            'Soma-se o total pago até a data mostrada por cada empresa que já pagou. Depois se calcula a média entre essas empresas.',
        leitura: 'Quanto cada empresa pagou em média até agora, sem prever pagamentos futuros.',
    },
    evolucaoReceita: {
        calculo: 'Cada ponto refaz MRR ou ARR para a data correspondente.',
        leitura: 'Trajetória da receita recorrente.',
    },
    // Assinaturas > Churn (guia, p. 14-15). Expiracao conta como cancelamento.
    cancelamentosAssinaturas: {
        calculo: 'Empresas que cancelaram (ou cuja assinatura expirou) entre as datas escolhidas, contadas uma vez.',
        leitura: 'Volume de saídas.',
    },
    churnNoPeriodo: {
        calculo:
            'Empresas pagantes no início que cancelaram (ou expiraram) no período, divididas por todas as pagantes no início, vezes 100. Com filtro de status, a taxa fica indisponível.',
        leitura: 'Parcela da base inicial perdida no intervalo.',
    },
    churnMensal: {
        calculo:
            'Pagantes no último dia do mês anterior ao da data final escolhida que cancelaram (ou expiraram) desde o primeiro dia do mês dessa data, divididas pelas pagantes daquele último dia, vezes 100. Com filtro de status, a taxa fica indisponível.',
        leitura: 'Perda da base inicial no mês da data final escolhida.',
    },
    churnAnual: {
        calculo:
            'Pagantes no início de 12 meses completos que cancelaram (ou expiraram) durante esses meses, divididas pelas pagantes do início, vezes 100. Sem 12 meses completos, o card fica sem valor. Com filtro de status, a taxa fica indisponível.',
        leitura: 'Perda da base inicial em um ano.',
    },
    mrrCanceladoAssinaturas: {
        calculo:
            'Soma do valor mensal equivalente das assinaturas de empresas que cancelaram (ou expiraram) no período.',
        leitura: 'Valor recorrente mensal associado às saídas.',
    },
    churnDeMrr: {
        calculo:
            'Valor mensal das assinaturas de pagantes do início que cancelaram (ou expiraram) no período, dividido pelo MRR das pagantes no início, vezes 100. Com filtro de status, a taxa fica indisponível.',
        leitura: 'Parcela da receita recorrente inicial perdida com cancelamentos.',
    },
    receitaPerdidaReal: {
        calculo:
            'Exigiria apurar pagamentos não recebidos, descontos, estornos e obrigações após cada cancelamento. O card fica sem valor enquanto essa conta não puder ser fechada.',
        leitura: 'Evita confundir valor contratado com dinheiro efetivamente perdido.',
    },
    trialAtePrimeiroPagamento: {
        calculo:
            'Média dos dias entre o cadastro no plano gratuito e o primeiro pagamento, apenas entre empresas que passaram pelos dois momentos.',
        leitura: 'Tempo médio para converter o plano gratuito em pagamento.',
    },
    ateCancelamento: {
        calculo: 'Média dos dias entre início da assinatura e cancelamento, entre empresas que cancelaram no período.',
        leitura: 'Tempo de permanência das empresas que saíram.',
    },
    evolucaoCancelamentos: {
        calculo:
            'Cada ponto mostra Cancelamentos ou Churn por conta no intervalo correspondente. Churn por conta divide as saídas da base pagante inicial pelas pagantes do início daquele intervalo, vezes 100.',
        leitura: 'Acompanha o volume e a proporção de saídas.',
    },
    // Mapeamento de clientes (guia, p. 16-18)
    contasCriadas: {
        calculo: 'Empresas cadastradas entre as datas escolhidas.',
        leitura: 'Tamanho do grupo analisado nesta página.',
    },
    responderam: {
        calculo:
            'Empresas cadastradas no período que responderam à pesquisa até a data mostrada. O percentual divide esse número por Contas criadas no período.',
        leitura: 'Cobertura da pesquisa.',
    },
    semResposta: {
        calculo: 'Contas criadas no período menos Responderam.',
        leitura: 'Empresas sem resposta registrada.',
    },
    setorMaisFrequente: {
        calculo: 'Setor com mais empresas entre as respondentes do período.',
        leitura: 'Perfil de setor mais comum entre quem respondeu.',
    },
    controleMaisComum: {
        calculo: 'Forma de controlar as finanças mais citada pelas respondentes do período.',
        leitura: 'Prática de controle mais comum.',
    },
    setorAgrupado: {
        calculo:
            'Respondentes reunidas por setor a partir do segmento escolhido. Cada percentual divide as empresas do setor por Responderam.',
        leitura: 'Distribuição por grandes tipos de negócio.',
    },
    comoControla: {
        calculo: 'Respondentes em cada forma de controle declarada, divididas por Responderam para obter cada percentual.',
        leitura: 'Hábitos financeiros declarados.',
    },
    segmentoInformado: {
        calculo: 'Respondentes em cada segmento declarado, divididas por Responderam para obter cada percentual.',
        leitura: 'Tipos de negócio na base respondente.',
    },
    faturamentoDeclarado: {
        calculo:
            'Respondentes em cada faixa de faturamento anual informada, divididas por Responderam para obter cada percentual.',
        leitura: 'Porte declarado, sem representar faturamento verificado.',
    },
    numeroFuncionarios: {
        calculo: 'Respondentes em cada faixa de funcionários informada, divididas por Responderam para obter cada percentual.',
        leitura: 'Tamanho declarado das equipes.',
    },
    objetivosDeclarados: {
        calculo:
            'Para cada objetivo, respondentes que o marcaram divididas por Responderam. Uma empresa pode marcar vários objetivos e os percentuais podem somar mais de 100%.',
        leitura: 'Necessidades mais citadas.',
    },
    comoConheceu: {
        calculo:
            'Para cada origem, respondentes que a marcaram divididas por Responderam. Uma empresa pode indicar mais de uma origem e os percentuais podem somar mais de 100%.',
        leitura: 'Caminhos pelos quais conheceram o produto.',
    },
    setorXComportamento: {
        calculo:
            'Dentro de cada setor, Pagantes divide pagantes pelas respondentes do setor; CRFA no grupo divide empresas com rotina financeira ativa pelo mesmo grupo; Ausentes divide respondentes que já acessaram, mas cujo último acesso foi há mais de 30 dias, pelas respondentes do setor. Nesse gráfico, Ausentes pode incluir empresas sem acesso atual.',
        leitura: 'Compara comportamento entre setores.',
    },
    controleXAtivacao: {
        calculo:
            'Dentro de cada forma de controle, Ativadas divide empresas que chegaram à primeira análise após registrar informações pelas respondentes do grupo; CRFA no grupo divide empresas com rotina financeira ativa pelo mesmo grupo.',
        leitura: 'Compara a ativação entre formas declaradas de controle.',
    },
    respostasPorCliente: {
        calculo:
            'Uma linha por empresa cadastrada no período, com respostas e data da pesquisa. Somente respondentes restringe a lista a empresas com resposta.',
        leitura: 'Permite conferir quem compõe os gráficos e localizar quem não respondeu.',
    },
} as const satisfies Record<string, MetricInfo>;

export type MetricInfoKey = keyof typeof METRIC_INFO;
